/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openFinanceSlideout } from '../../actions/lister-actions';
import { FinanceInstallments } from './FinanceInstallments';
import { buildSlideoutPayload } from '../../utilities/finance-utilities';

const FinanceWithChevron = ({
	NewDayFinanceQuote,
	MemberPrice,
	NowPrice,
	Code,
	ColourId,
	PromotionType,
	PromotionMonths,
	financePromotions,
	State,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false,
	},
	isSwitch24Product,
	Switch24Pricing,
	representativeAprRateString,
	purchaseAprRateString,
	useEnhancedFinanceProposition,
	isFinancePromotion,
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee, UseUpfrontPricingAmounts, UseSwitch24 } =
		useSelector((state) => state.featureSwitches);

	const slideoutPayload = buildSlideoutPayload({
		ColourId,
		Code,
		NowPrice,
		MemberPrice,
		AnnualMembershipFee,
		PromotionType,
		PromotionMonths,
		FinancePromotions: financePromotions,
		State,
		UpfrontPricing,
		Switch24Pricing,
		UseUpfrontPricingAmounts,
		UseSwitch24,
		representativeAprRateString,
		purchaseAprRateString,
	});

	const openFinanceSlideoutWithPayload = () => {
		dispatch(openFinanceSlideout(slideoutPayload));
	};

	const switchMonthlyPayment =
		Switch24Pricing?.Switch24FinanceQuote?.MonthlyPayment;

	const installmentsProps = {
		UpfrontPricing,
		UseUpfrontPricingAmounts,
		NewDayFinanceQuote,
		isSwitch24Product,
		switchMonthlyPayment,
		useEnhancedFinanceProposition,
		isFinancePromotion,
	};

	if (useEnhancedFinanceProposition) {
		return (
			<div
				aria-label="Instalments Finance Promotion"
				className="text-left leading-tight text-body-xs z-10 relative"
				data-tag-name="non-member-display-monthly-installments-button"
				data-testid="non-member-lister-finance-instalments">
				<FinanceInstallments {...installmentsProps} />
				<span
					className="font-bold text-cta-action ml-1 cursor-pointer text-body-xs lg:text-sm"
					role="link"
					tabIndex={0}
					onClick={openFinanceSlideoutWithPayload}
					data-tag-name={
						isSwitch24Product
							? 'Switch24 Button'
							: 'non-member-display-monthly-installments-button'
					}
					data-testid="finance-learn-more-link">
					Learn more
				</span>
			</div>
		);
	}

	return (
		<div
			aria-label="Instalments Finance Promotion"
			className={`ml-0 cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative ${
				isSwitch24Product ? 'mb-0' : 'mb-3'
			}`}
			tabIndex={0}
			role="link"
			onClick={openFinanceSlideoutWithPayload}
			data-tag-name="non-member-display-monthly-installments-button"
			data-testid="non-member-lister-finance-instalments">
			<FinanceInstallments {...installmentsProps} />
		</div>
	);
};

export default FinanceWithChevron;
